import { TicketType, ticketTypes } from "./TicketType";

interface TicketTypeLabelProps {
  value: TicketType;
}

export default function TicketTypeLabel({ value }: TicketTypeLabelProps) {
  const ticketType = ticketTypes.find((type) => type.id === value);

  return <div>{ticketType?.name}</div>;
}
